export default {
  addError(state, rawError) {
    state.errors.push(rawError);
    state.showError = true;
  },
  clearAll(state) {
    state.errors = [];
    state.showError = false;
  },
};
